import styled from '@emotion/styled';

import { breakpoints } from '~/src/styles';

const smallButtonSize = '35px';
const mobileSmallButtonSize = '30px';

const bigButtonSize = '90px';
const mobileBigButtonSize = '75px';

const commonBtnStyles = `
  opacity: 0.7;
  transition: opacity 1s;
  &:hover{
    transition: opacity 0.3s;
    opacity: 1;
  }
`;

const smallBrightcoveBtnStyles = `
  font-size: ${mobileSmallButtonSize};
  ${breakpoints.minMobileLandscape} {
    font-size: ${smallButtonSize};
  }
`;

const smallCustomBtnStyles = `
  display: flex !important;
  align-items: center;
  justify-content: center;
  img {
    width: 100%;
    height: 100%;
  }
`;
const smallButtonStyles = `
  ${smallBrightcoveBtnStyles}
  ${smallCustomBtnStyles}
  ${commonBtnStyles}

  width: ${mobileSmallButtonSize} !important;
  height: ${mobileSmallButtonSize};
  ${breakpoints.minMobileLandscape} {
    width: ${smallButtonSize} !important;
    height: ${smallButtonSize};
  }
`;

const timeStyles = `
    font-family: 'Montserrat';
    letter-spacing: 0.9px;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    color: #fff;
    margin: 0 !important;
    padding: 0 !important;
    width: 32px;
`;

const bigBrightcoveButtonStyles = `
  width: ${mobileBigButtonSize} !important;
  height: ${mobileBigButtonSize};
  font-size: ${mobileBigButtonSize};
  ${breakpoints.minMobileLandscape} {
    width: ${bigButtonSize} !important;
    height: ${bigButtonSize};
    font-size: ${bigButtonSize};
  }
  ${commonBtnStyles}
`;

export const Body = styled.div`
  width: 90%;
  height: 100%;
  ${breakpoints.minMobileLandscape} {
    width: 80%;
  }

  ${breakpoints.minTablet} {
    width: 70%;
  }
  display: flex;
  flex-direction: column;
  row-gap: 10px;
`;

export const PlayerStylesWrapper = styled.div`
  width: 100%;
  flex: 1;
  .vjs-poster {
    display: none !important;
  }
  .video-js {
    background: transparent !important;
    overflow: visible !important;
  }
  .vjs-icon-placeholder:before {
    font-size: unset;
    line-height: unset;
  }
  .vjs-big-play-button {
    display: none;
  }

  .vjs-control {
    display: none;
  }
  .vjs-control-bar {
    display: grid !important;
    height: 100%;
    background: transparent !important;
    justify-items: center;
    align-items: center;

    position: absolute;
    bottom: 0;
    height: auto;

    font-size: 10px !important;
    height: auto !important;

    column-gap: 12px;
    grid-template-columns: auto 1fr 1fr 1fr 2.5fr 1fr 1fr auto;
    grid-template-rows: max-content 34px max-content;
    grid-template-areas:
      '. info-btn volume rewind-10-sec-btn play-btn forward-30-sec-btn closed-captions-btn .'
      'progress-control progress-control progress-control progress-control progress-control progress-control progress-control progress-control'
      'current-time current-time . . . . duration duration';

    ${breakpoints.minMobileLandscape} {
      column-gap: 20px;
      grid-template-columns: auto 1fr ${smallButtonSize} ${smallButtonSize} ${smallButtonSize} ${bigButtonSize} ${smallButtonSize} ${smallButtonSize} 1fr auto;
      grid-template-rows: max-content 34px;
      grid-template-areas:
        '. . info-btn volume rewind-10-sec-btn play-btn forward-30-sec-btn closed-captions-btn . .'
        'current-time progress-control progress-control progress-control progress-control progress-control progress-control progress-control progress-control duration';
    }
  }

  .vjs-play-control {
    grid-area: play-btn;
    display: block !important;
    ${bigBrightcoveButtonStyles}
  }

  .vjs-skip-ahead-btn {
    grid-area: forward-30-sec-btn;
    ${smallButtonStyles}
  }

  .vjs-rewind-n-seconds {
    grid-area: rewind-10-sec-btn;
    ${smallButtonStyles}
  }

  .vjs-volume-panel {
    display: block !important;
    grid-area: volume;
    height: ${mobileSmallButtonSize};
    width: ${mobileSmallButtonSize} !important;
    ${breakpoints.minMobileLandscape} {
      height: ${smallButtonSize};
      width: ${smallButtonSize} !important;
    }

    --handler-width: 6px;
    .vjs-button {
      ${smallButtonStyles}
    }

    .vjs-volume-control {
      display: block !important;
    }

    .vjs-volume-vertical {
      height: 127px !important;
      padding-bottom: 26px;
      bottom: 127px;
      padding-top: 13px;
      background: none;
    }

    .vjs-volume-vertical {
      bottom: 32px;
      position: absolute !important;
    }
    &.vjs-hover .vjs-volume-vertical {
      left: 0 !important;
    }

    .vjs-volume-bar {
      margin: 0 auto;
      height: 100%;
      width: var(--handler-width);
      .vjs-mouse-display {
        background: none !important;
      }
    }

    .vjs-volume-level {
      opacity: 0.8;
      width: var(--handler-width);
      &:after {
        content: '';
        display: inline-block;
        background-color: currentColor;
        width: 14px;
        height: 14px;
        transform: translate(-50%, -50%);
        border-radius: 50%;
        left: 50%;
        position: absolute;
      }
    }
  }
  .vjs-current-time {
    display: block !important;
    grid-area: current-time;
    text-align: left;
    ${timeStyles}
  }
  .vjs-time-divider {
    display: none;
  }

  .vjs-duration {
    display: block !important;
    grid-area: duration;
    text-align: right;
    ${timeStyles}
  }
  .vjs-info-button {
    grid-area: info-btn;
    ${smallButtonStyles}
  }
  .vjs-fullscreen-control {
    display: none;
  }

  .vjs-fullscreen-control {
    display: none;
  }

  .vjs-progress-control {
    display: block !important;
    grid-area: progress-control;
    bottom: 50% !important;
    top: unset !important;
  }
  .vjs-subs-caps-button {
    &.vjs-hidden {
      display: none !important;
    }
    grid-area: closed-captions-btn;
    display: block !important;
    height: ${mobileSmallButtonSize};
    width: ${mobileSmallButtonSize} !important;
    ${breakpoints.minMobileLandscape} {
      height: ${smallButtonSize};
      width: ${smallButtonSize} !important;
    }

    .vjs-button {
      ${smallButtonStyles}
    }
  }
  .vjs-text-track-display {
    bottom: 140px !important;
  }
`;

export const Container = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  overflow: hidden;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`;
